import React, { Component } from 'react';
import { GatewayProvider } from 'react-gateway';
import 'reset-css';
import classNames from 'classnames';
import { getViewModeSearchParam, fetchAppData, fetchTPASettings } from '@wix/communities-blog-client-common';

import AppWrapper from '../../../app/components/app-wrapper';
import AccessibilityListener from '../../../app/components/accessibility-listener';
import { setSearchParams } from '../../../app/actions/set-search-params';
import { setUser } from '../../../app/actions/set-user';
import { waitForAppSettings } from '../../../app/actions/fetch-app-settings';
import { setViewMode } from '../../../app/actions/set-view-mode';
import { setExperiments } from '../../../app/actions/set-experiments';
import fetchFeedPosts from '../../../app/actions/fetch-feed-posts';
import { fetchCategoryPosts } from '../../../app/actions/fetch-category-posts';
import { setDemoMode } from '../../../app/actions/set-demo-mode';
import { fetchWidgetPosts } from '../../services/fetch-widget-posts';
import { getWidgetPostsProps } from '../../services/widget-posts-props';
import { getPostsPerPage } from '../../selectors/layout-config-selectors';
import { getWidgetIsFeaturedPost } from '../../selectors/app-settings-selectors';
import fedopsLogger from '../../services/fedops-logger';
import * as appLifecycleService from '../../../app/services/app-lifecycle-service';
import WidgetPosts from '../widget-posts';
import styles from './root.scss';

class Root extends Component {
  static fetchData = ({ store, searchParams, user, demoMode, experiments }) => {
    const promises = [
      store.dispatch(setSearchParams(searchParams)),
      store.dispatch(setViewMode(getViewModeSearchParam(store.getState()))),
      store.dispatch(setDemoMode(Boolean(demoMode))),
      store.dispatch(setExperiments(experiments)),
      user ? store.dispatch(setUser(user)) : Promise.resolve(),
    ];

    return Promise.all(promises).then(() =>
      Promise.all([
        store.dispatch(
          waitForAppSettings(() => {
            const state = store.getState();
            return fetchWidgetPosts({
              categoryId: getWidgetPostsProps(state).categoryId,
              paginationParams: { page: 1, pageSize: getPostsPerPage(state) },
              featuredOnly: getWidgetIsFeaturedPost(state),
              fetchCategoryPosts,
              fetchFeedPosts,
              excludeContent: true,
            });
          }, true),
        ),
        store.dispatch(fetchTPASettings()),
        store.dispatch(fetchAppData()),
      ]),
    );
  };

  componentDidMount() {
    fedopsLogger.appLoaded();
    appLifecycleService.appLoaded();
  }

  render() {
    return (
      <GatewayProvider>
        <AppWrapper className={classNames(styles.container, 'blog-background-color')} id="content-wrapper">
          <AccessibilityListener />
          <WidgetPosts />
        </AppWrapper>
      </GatewayProvider>
    );
  }
}

export default Root;
